import { RocketLaunch } from "@phosphor-icons/react";
import { Epic, EpicStatus } from "shared/types/epic";
import { PickerItemProps } from "../../types";

export const EpicItem = ({ item, isSelected, onSelect }: PickerItemProps<Epic>) => {
  const getStatusColor = (status: EpicStatus) => {
    switch (status) {
      case EpicStatus.PLANNING:
        return "bg-blue-100 text-blue-700 border-blue-300";
      case EpicStatus.IN_PROGRESS:
        return "bg-moss-primary/10 text-moss-primary border-moss-primary/30";
      case EpicStatus.COMPLETED:
        return "bg-green-100 text-green-700 border-green-300";
      case EpicStatus.ON_HOLD:
        return "bg-gray-100 text-gray-700 border-gray-300";
      default:
        return "bg-neutral-100 text-neutral-700 border-neutral-300";
    }
  };

  // Calculate progress if features are available
  const progress = item.features ? {
    total: item.features.length,
    completed: item.features.filter(f => f.status === 'Opgelost' || f.status === 'Gesloten').length
  } : null;

  const progressPercent = progress && progress.total > 0
    ? Math.round((progress.completed / progress.total) * 100)
    : 0;

  return (
    <button
      onClick={() => onSelect(item)}
      className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors hover:bg-brick-secondary-fine ${
        isSelected ? "bg-moss-primary/10 border border-moss-primary/30" : ""
      }`}
    >
      <div className="flex items-start gap-2">
        <RocketLaunch className="h-4 w-4 text-moss-primary shrink-0 mt-0.5" weight="duotone" />
        <div className="flex-1 min-w-0">
          <div className="font-medium text-neutral-primary truncate">
            {item.title}
          </div>
          {item.description && (
            <div className="text-xs text-neutral-secondary-mid truncate mt-0.5">
              {item.description}
            </div>
          )}
          <div className="flex items-center gap-2 mt-1">
            <div className={`px-2 py-0.5 rounded-md border text-xs ${getStatusColor(item.status)}`}>
              {item.status}
            </div>
            {progress && progress.total > 0 && (
              <div className="text-xs text-neutral-600">
                {progress.completed}/{progress.total} ({progressPercent}%)
              </div>
            )}
          </div>
        </div>
      </div>
    </button>
  );
};
